import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const CircleCrossIcon = ({
  color = 'foraBlue',
  width = 20,
  marginLeft,
  marginRight,
  containerSize,
  title = 'Error',
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    width={width}
    title={title}
  >
    <svg
      width={Number(width)}
      height={Number(width)}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          id="union"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11ZM19.5 11C19.5 15.6944 15.6944 19.5 11 19.5C6.30558 19.5 2.5 15.6944 2.5 11C2.5 6.30558 6.30558 2.5 11 2.5C15.6944 2.5 19.5 6.30558 19.5 11ZM7.4644 14.5356C7.07388 14.1451 7.07388 13.5119 7.4644 13.1214L9.58576 11L7.4645 8.87876C7.07397 8.48824 7.07397 7.85507 7.4645 7.46455C7.85502 7.07402 8.48818 7.07402 8.87871 7.46455L11 9.58581L13.1213 7.46452C13.5118 7.074 14.1449 7.074 14.5355 7.46452C14.926 7.85505 14.926 8.48821 14.5355 8.87874L12.4142 11L14.5356 13.1214C14.9261 13.5119 14.9261 14.1451 14.5356 14.5356C14.145 14.9261 13.5119 14.9261 13.1213 14.5356L11 12.4142L8.87862 14.5356C8.48809 14.9261 7.85493 14.9261 7.4644 14.5356Z"
          fill={getSemanticTextColor(color)}
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
